export default __webpack_public_path__ + "static/media/512.a53c02f8.gif";